import React from 'react';
interface FastProfitLogoProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}
export function FastProfitLogo({
  size = 'md',
  className = ''
}: FastProfitLogoProps) {
  const sizeClasses = {
    sm: {
      eyebrow: 'text-[10px] tracking-widest',
      script: 'text-3xl',
      sub: 'text-[10px] tracking-wider',
      gap: 'gap-1',
      rule: 'w-8'
    },
    md: {
      eyebrow: 'text-xs tracking-[0.2em]',
      script: 'text-5xl',
      sub: 'text-xs tracking-[0.15em]',
      gap: 'gap-2',
      rule: 'w-12'
    },
    lg: {
      eyebrow: 'text-sm tracking-[0.25em]',
      script: 'text-7xl',
      sub: 'text-sm tracking-[0.2em]',
      gap: 'gap-3',
      rule: 'w-16'
    }
  };
  const s = sizeClasses[size];
  return <div className={`flex flex-col items-center justify-center ${s.gap} ${className}`} data-id="element-49">
      <div className="flex items-center gap-3" data-id="element-50">
        <div className={`h-[1px] bg-brand-gold ${s.rule}`} data-id="element-51"></div>
        <span className={`font-display font-bold text-brand-gold uppercase ${s.eyebrow}`} data-id="element-52">
          Bigger Profits Presents
        </span>
        <div className={`h-[1px] bg-brand-gold ${s.rule}`} data-id="element-53"></div>
      </div>

      <h1 className={`font-script text-white leading-none ${s.script}`} style={{
      textShadow: '0 2px 10px rgba(0,0,0,0.5)'
    }} data-id="element-54">
        FAST PROFIT
      </h1>

      <div className="w-full h-[1px] bg-brand-gold/50 max-w-[80%]" data-id="element-55"></div>

      <span className={`font-display text-white uppercase ${s.sub}`} data-id="element-56">
        The 90-Minute CRE Workshop
      </span>
    </div>;
}